import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import MomentTZ from 'moment-timezone';
import { Redirect } from 'react-router-dom';
import FlightSelection from '../flightSelection/FlightSelection';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import Features from '../../const/Features';
import FeatureService from './../../services/feature/FeatureService.js';
import AvailabilityService from './../../services/availability/AvailabilityService';
import FilterUnavailableFlights from '../../usecases/filterUnavailableFlighs/FilterUnavailableFlights';
import I18n from 'i18n-react';
import FlightHistoryService from '../../services/flightHistory/FlightHistoryService';
import EventEmitter from '../modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import { EXCLUDED_OPERATING_CARRIER } from '../../const/Company';
import { Button } from 'react-bootstrap';
import GifPlaneLoader from '../flightSelection/flightOptions/gifPlaneLoader/GifPlaneLoader.jsx';
import './FlightSelectionContainer.css';

const propTypes = {
  departureFlights: PropTypes.object.isRequired,
  returnFlights: PropTypes.object,
  filter: PropTypes.object.isRequired,
  callbackSelectFlights: PropTypes.func,
  callbackAlterFlights: PropTypes.func,
  callbackDepartureDelete: PropTypes.string,
  callbackReturnDelete: PropTypes.string,
  updatePage: PropTypes.func.isRequired,
  origin: PropTypes.string.isRequired,
  finalDestination: PropTypes.string.isRequired,
  originAirportName: PropTypes.string.isRequired,
  finalDestinationAirportName: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  isFromDeeplink: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  returnFlights: {}
};

const AZUL_COMPANY_CODE = 'AD';

class FlightSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      messageInfo: null,
      minSelectionDate: Moment()
        .startOf('day')
        .add(4, 'day')
        .toISOString(),
      maxSelectionDate: Moment()
        .startOf('day')
        .add(345, 'day')
        .toISOString(),
      departureFlights: this.props.departureFlights.flights,
      returnFlights: this.props.returnFlights.flights,
      startDate: Moment(this.props.filter.startDate).format('DD/MM/YYYY'),
      endDate: this.props.filter.endDate
        ? Moment(this.props.filter.endDate).format('DD/MM/YYYY')
        : null,
      alterSearch: false,
      toogleElapsedFlightTime: false,
      toggleDetailsModal: false,
      isGridLoading: true,
      getAvailabilityFirstTime: this.props.isFromDeeplink ? true : false,
      filteredList: {
        baggageList: [],
        stopoverList: [],
        companiesList: []
      },
      originalDepartureFlights: [],
      originalReturnFlights: [],
      departureFlightsFiltered: this.props.departureFlights.flights,
      returnFlightsFiltered: this.props.returnFlights.flights,
      incPagination: 1,
      departureFlightsAcumulationPagination: [],
      showButtonPagination: false,
      numPagination: 1
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleAlterSearch = this.handleAlterSearch.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.validateDateRules = this.validateDateRules.bind(this);
    this.validateStartDateBeforeMinDate = this.validateStartDateBeforeMinDate.bind(this);
    this.validateEndDateBeforeMinDate = this.validateEndDateBeforeMinDate.bind(this);
    this.validateEndDateBeforeStartDate = this.validateEndDateBeforeStartDate.bind(this);
    this.validateStartDateAfterMaxDate = this.validateStartDateAfterMaxDate.bind(this);
    this.validateEndDateAfterMaxDate = this.validateEndDateAfterMaxDate.bind(this);

    this.updateFilters = this.updateFilters.bind(this);
    this.filtersOperation = this.filtersOperation.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.updateFilterReturnFlights = this.updateFilterReturnFlights.bind(this);
    this.setShowButtonPaginationReturn = this.setShowButtonPaginationReturn.bind(this);
  }

  componentDidMount() {
    this.featureElapsedFlightTime();
    this.featureDetailsModal();
    this.firstAvailabilityOrUnavailableFlights(1);
    this.featureSortList();
  }

  featureElapsedFlightTime() {
    FeatureService.isFeatureEnabled(Features.ELAPSED_FLIGHT_TIME).then(isEnabled => {
      this.setState({
        toogleElapsedFlightTime: isEnabled
      });
    });
  }

  featureDetailsModal() {
    FeatureService.isFeatureEnabled(Features.DETAILS_MODAL).then(isEnabled => {
      this.setState({
        toggleDetailsModal: isEnabled
      });
    });
  }

  featureSortList() {
    FeatureService.isFeatureEnabled(Features.SORT_FLIGHTS_BY_FLIGHT_GROUP).then(isEnabled => {
      this.setState({
        toggleSortList: isEnabled
      });
    });
  }

  firstAvailabilityOrUnavailableFlights(numPagination) {
    if (this.state.getAvailabilityFirstTime) {
      const recoveryState = {
        startDate: this.state.startDate
      };

      const filter = this.props.filter;
      this.handleSearch(filter, recoveryState, false, numPagination);
    } else {
      this.handleSearch(this.props.filter, this.props.filter.startDate, false, numPagination);
    }
  }

  handleSearch(filter, recoveryState, isFromDateCarousel, numPagination) {
    const request = {
      tripType: filter.typeTrip === 'roundTrip' ? 'ROUND_TRIP' : 'ONE_WAY',
      origin: filter.flightOrigin.code,
      destination: filter.flightDestiny.code,
      adult: filter.totalAdults,
      child: filter.totalKids,
      infant: filter.totalBabys,
      typeOfFlight: filter.typeOfFlight === 'A' ? 'ALL' : 'DIRECT',
      companiesIdentity: filter.companiesIdentity === '-' ? '-' : filter.companiesIdentity
    };

    if (filter.cabinCategory === '-') {
      request.cabinCategory = 'ECONOMY';
      this.props.filter.cabinCategory = 'ECONOMY';
    } else {
      request.cabinCategory = filter.cabinCategory;
    }

    request.departureDateTime = MomentTZ(filter.startDate).format();
    if (filter.endDate) {
      request.returnDateTime = MomentTZ(filter.endDate).format();
    }
    request.page = numPagination;
    EventEmitter.emitEvent(Listener.LOADED_AVAILABILITY, false);
    this.setState({
      isGridLoading: true,
      startDate: Moment(request.departureDateTime).format('DD/MM/YYYY'),
      endDate: filter.endDate ? Moment(request.returnDateTime).format('DD/MM/YYYY') : null,
      numPagination: numPagination,
      showButtonPagination: false
    });
    AvailabilityService.getAvailability(request)
      .then(response => {
        if (response.error) throw response;
        FeatureService.isFeatureEnabled(Features.FLIGHT_HISTORY_SERVICE).then(isEnabled => {
          if (!isFromDateCarousel && isEnabled) {
            FlightHistoryService.updateRecentFlights(filter);
          }
        });

        FilterUnavailableFlights.execute(response.departureFlights.flights).then(flights => {
          EventEmitter.emitEvent(Listener.LOADED_AVAILABILITY, true);
          this.setAcumulationFlightOfPagination(response, flights);
          const flightsAcumulatorPagination = this.state.departureFlightsAcumulationPagination;
          if (this.state.toggleSortList) {
            let isFiltred = this.isAnyFiltred(this.state.filteredList);
            let departureFlightsOptionFiltered = null;
            let returnFlightsSorted = this.sortByQtdFlightGroup(response.returnFlights.flights);
            if (isFiltred) {
              departureFlightsOptionFiltered = this.filtersOperation(
                flightsAcumulatorPagination,
                this.state.filteredList
              );
            }
            this.setState({
              departureFlightsFiltered:
                departureFlightsOptionFiltered === null
                  ? flightsAcumulatorPagination
                  : departureFlightsOptionFiltered,
              originalDepartureFlights: flightsAcumulatorPagination,
              returnFlightsFiltered: returnFlightsSorted,
              originalReturnFlights: returnFlightsSorted,
              numPagination: response.pagination.page
            });
          } else {
            let isFiltred = this.isAnyFiltred(this.state.filteredList);
            let departureFlightsOptionFiltered = null;
            if (isFiltred) {
              departureFlightsOptionFiltered = this.filtersOperation(
                flightsAcumulatorPagination,
                this.state.filteredList
              );
            }
            this.setState({
              departureFlightsFiltered:
                departureFlightsOptionFiltered === null
                  ? flightsAcumulatorPagination
                  : departureFlightsOptionFiltered,
              originalDepartureFlights: flightsAcumulatorPagination,
              returnFlightsFiltered: response.returnFlights.flights,
              originalReturnFlights: response.returnFlights.flights,
              numPagination: response.pagination.page
            });
          }
          this.setState({
            isGridLoading: false,
            showButtonPagination: !response.pagination.isFinalPagination,
            incPagination: response.pagination.page
          });
          if (this.props.callbackDepartureDelete != null) {
            if (this.props.callbackReturnDelete != null) {
              let returnFlights = this.state.returnFlightsFiltered;
              returnFlights.forEach(flight => {
                if (flight.id == this.props.callbackReturnDelete) {
                  let index = returnFlights.indexOf(flight);
                  returnFlights.splice(index, 1);
                }
              });
              this.setState({
                returnFlightsFiltered: returnFlights
              });
            }
            let departureFlights = this.state.departureFlightsFiltered;
            departureFlights.forEach(flight => {
              if (flight.id == this.props.callbackDepartureDelete) {
                let index = departureFlights.indexOf(flight);
                departureFlights.splice(index, 1);
              }
            });
            this.setState({
              departureFlightsFiltered: departureFlights
            });
            sessionStorage.clear();
          }
          EventEmitter.emitEvent(Listener.SEND_ANALYTICS_TAG, filter, response);
        });
        this.props.updatePage();
      })
      .catch(error => {
        const rollbackState = {
          isGridLoading: false,
          incPagination: this.state.incPagination - 1,
          showButtonPagination: numPagination > 1
        };

        if (recoveryState.startDate) {
          rollbackState.startDate = recoveryState.startDate;
          this.props.filter.startDate = Moment(recoveryState.startDate, 'DD/MM/YYYY').format();
        }

        if (recoveryState.endDate) {
          rollbackState.endDate = recoveryState.endDate;
          this.props.filter.endDate = Moment(recoveryState.endDate, 'DD/MM/YYYY').format();
        }

        this.setState(rollbackState);
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  setAcumulationFlightOfPagination(response, flights) {
    if (response.pagination.page > 1) {
      flights.map(flightResponse => {
        this.setState({
          departureFlightsAcumulationPagination: [
            ...this.state.departureFlightsAcumulationPagination,
            flightResponse
          ]
        });
      });
    } else {
      this.setState({
        departureFlightsAcumulationPagination: flights
      });
    }
  }

  isAnyFiltred(filteredList) {
    if (
      filteredList.companiesList.length > 0 ||
      filteredList.baggageList.length > 0 ||
      filteredList.stopoverList.length > 0
    ) {
      return true;
    }
    return false;
  }

  handleStartDateChange(startDate) {
    if (this.validateDateRules(startDate, Moment(this.state.endDate, 'DD/MM/YYYY').toISOString())) {
      const recoveryState = {
        startDate: this.state.startDate
      };

      this.setState(() => ({
        originalDepartureFlights: [],
        originalReturnFlights: [],
        incPagination: 1,
        showButtonPagination: false
      }));

      const filter = this.props.filter;
      filter.startDate = startDate;
      this.handleSearch(filter, recoveryState, true, 1);
    }
  }

  handleEndDateChange(endDate) {
    if (this.validateDateRules(Moment(this.state.startDate, 'DD/MM/YYYY').toISOString(), endDate)) {
      const recoveryState = {
        endDate: this.state.endDate
      };
      this.setState({
        originalReturnFlights: [],
        incPagination: 1,
        showButtonPagination: false
      });
      const filter = this.props.filter;
      filter.endDate = endDate;
      this.handleSearch(filter, recoveryState, true, 1);
    }
  }

  handleAlterSearch() {
    this.setState({
      alterSearch: true
    });
  }

  validateDateRules(startDate, endDate) {
    var hasValidSearch = true;

    if (this.validateStartDateBeforeMinDate(startDate)) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.startDateBeforeMinDate', {
          date: Moment(this.state.minSelectionDate)
            .subtract(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    if (hasValidSearch && this.validateStartDateAfterMaxDate(startDate)) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.startDateAfterMaxDate', {
          date: Moment(this.state.maxSelectionDate)
            .add(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    if (endDate) {
      if (this.validateEndDateBeforeMinDate(endDate)) {
        hasValidSearch = false;
        this.showModal(
          I18n.translate('home.msg.endDateBeforeMinDate', {
            date: Moment(this.state.minSelectionDate).format('DD/MM/YYYY')
          })
        );
      }

      if (hasValidSearch && this.validateEndDateAfterMaxDate(endDate)) {
        hasValidSearch = false;
        this.showModal(
          I18n.translate('home.msg.endDateAfterMaxDate', {
            date: Moment(this.state.maxSelectionDate)
              .add(1, 'days')
              .format('DD/MM/YYYY')
          })
        );
      }

      if (hasValidSearch && this.validateEndDateBeforeStartDate(startDate, endDate)) {
        hasValidSearch = false;
        this.showModal(I18n.translate('home.msg.endDateBeforeStartDate'));
      }
    }

    return hasValidSearch;
  }

  validateStartDateBeforeMinDate(startDate) {
    return Moment(startDate).isBefore(Moment(this.state.minSelectionDate));
  }

  validateEndDateBeforeMinDate(endDate) {
    return Moment(endDate).isBefore(Moment(this.state.minSelectionDate));
  }

  validateEndDateBeforeStartDate(startDate, endDate) {
    return Moment(endDate).isBefore(Moment(startDate));
  }

  validateStartDateAfterMaxDate(startDate) {
    return Moment(startDate).isAfter(Moment(this.state.maxSelectionDate));
  }

  validateEndDateAfterMaxDate(endDate) {
    return Moment(endDate).isAfter(Moment(this.state.maxSelectionDate));
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
  }

  sortByQtdFlightGroup(flights) {
    return flights.sort(function(a, b) {
      return a.flightGroup.length > b.flightGroup.length
        ? 1
        : b.flightGroup.length > a.flightGroup.length
          ? -1
          : 0;
    });
  }

  clearFilters(flightType) {
    this.setState({
      isGridLoading: true
    });
    const emptyFilteredList = {
      baggageList: [],
      stopoverList: [],
      companiesList: []
    };

    this.setState(() => ({
      filteredList: emptyFilteredList
    }));

    switch (flightType) {
      case 0:
        this.setState({
          departureFlightsFiltered: this.state.originalDepartureFlights
        });
        break;

      case 1:
        this.setState(
          {
            isGridLoading: true,
            returnFlightsFiltered: this.state.originalReturnFlights
          },
          () => EventEmitter.emitEvent(Listener.LIST_CHANGE_FILTER, true)
        );
        break;
      default:
        break;
    }
    this.setState({
      isGridLoading: false
    });
  }

  updateFilters(selected, flightType) {
    this.setState({
      filteredList: selected.filteredList,
      isGridLoading: true
    });
    if (
      selected.filteredList.baggageList.length === 0 &&
      selected.filteredList.stopoverList.length === 0 &&
      selected.filteredList.companiesList.length === 0
    ) {
      switch (flightType) {
        case 0:
          this.setState({
            departureFlightsFiltered: this.state.originalDepartureFlights
          });
          break;

        case 1:
          this.setState(
            {
              returnFlightsFiltered: this.state.originalReturnFlights
            },
            () => EventEmitter.emitEvent(Listener.LIST_CHANGE_FILTER, true)
          );
          break;
        default:
          this.setState({
            departureFlightsFiltered: this.state.originalDepartureFlights
          });
      }
    } else {
      switch (flightType) {
        case 0:
          this.setState({
            departureFlightsFiltered: this.filtersOperation(
              this.state.originalDepartureFlights,
              selected.filteredList
            )
          });
          break;

        case 1:
          this.setState(
            {
              isGridLoading: true,
              returnFlightsFiltered: this.filtersOperation(
                this.state.originalReturnFlights,
                selected.filteredList
              )
            },
            () => EventEmitter.emitEvent(Listener.LIST_CHANGE_FILTER, true)
          );
          break;

        default:
          break;
      }
    }
    this.setState({
      isGridLoading: false
    });
  }

  updateFilterReturnFlights() {
    this.initializerFilterReturn();
  }

  initializerFilterReturn() {
    this.setState({
      filteredList: {
        baggageList: [],
        stopoverList: [],
        companiesList: []
      }
    });
  }

  filtersOperation = function(flights, filteredList) {
    let companiesList = [];
    let baggageList = [];
    let stopOverList = [];
    let finalList = [];
    finalList = flights;

    if (filteredList.companiesList !== undefined && filteredList.companiesList.length > 0) {
      finalList.forEach(flight => {
        let newFlightGroup = flight.flightGroup.filter(
          e =>
            e.marketingCarrier !== AZUL_COMPANY_CODE &&
            e.operatingCarrier !== EXCLUDED_OPERATING_CARRIER &&
            filteredList.companiesList.map(e => e.id).includes(e.marketingCarrier) === true
        );

        let validFlightGroup;
        let isAD = flight.flightGroup.filter(e => e.marketingCarrier !== AZUL_COMPANY_CODE);

        if (
          newFlightGroup.length !== 0 &&
          isAD.length !== 0 &&
          filteredList.companiesList.map(e => e.id).includes(isAD[isAD.length - 1].marketingCarrier)
        ) {
          validFlightGroup = flight.flightGroup[flight.flightGroup.length - 1];
        }
        if (isAD.length === 0 && filteredList.companiesList.map(e => e.id).includes('AD')) {
          validFlightGroup = flight.flightGroup[flight.flightGroup.length - 1];
        }

        if (validFlightGroup !== undefined && flight.flightGroup.includes(validFlightGroup)) {
          companiesList.push(flight);
        }
      });
      finalList = companiesList;
    }

    if (filteredList.baggageList !== undefined && filteredList.baggageList.length > 0) {
      switch (filteredList.baggageList[0].id) {
        case 0:
          finalList.forEach(flight => {
            if (flight.baggage !== null && flight.baggage[0].quantity !== null) {
              let newFlight = flight.baggage.filter(e => e.quantity === 0);
              if (flight.baggage.map(e => e.id).includes(newFlight[0])) baggageList.push(flight);
            }
          });
          finalList = baggageList;
          break;

        case 1:
          finalList.forEach(flight => {
            if (flight.baggage === null) {
              baggageList.push(flight);
            } else {
              let newFlight = flight.baggage.filter(e => e.quantity >= 1);
              if (flight.baggage.map(e => e.id).includes(newFlight[0])) baggageList.push(flight);
            }
          });
          finalList = baggageList;
          break;

        default:
          break;
      }
    }

    if (filteredList.stopoverList !== undefined && filteredList.stopoverList.length > 0) {
      switch (filteredList.stopoverList[0].id) {
        case 0:
          for (let i = 0; i < finalList.length; i++) {
            if (finalList[i].flightGroup.length < 2) {
              stopOverList.push(finalList[i]);
            }
          }
          finalList = stopOverList;
          break;

        case 1:
          for (let i = 0; i < finalList.length; i++) {
            if (finalList[i].flightGroup.length === 2) {
              stopOverList.push(finalList[i]);
            }
          }
          finalList = stopOverList;
          break;

        case 2:
          for (let j = 0; j < finalList.length; j++) {
            if (finalList[j].flightGroup.length > 2) {
              stopOverList.push(finalList[j]);
            }
          }
          finalList = stopOverList;
          break;

        default:
          break;
      }
    }
    return finalList;
  };

  renderButtonLoadingPagination() {
    if (this.state.isGridLoading && this.state.numPagination > 1)
      return (
        <div className="flightSelectionContainerGif">
          <div className="flightSelectionContainerGif__planeGif" span={24}>
            <GifPlaneLoader src="../styles/img/planeLoader_BF.gif" alt="" />
          </div>
          <div
            className="flightSelectionContainergGif flightSelectionContainerGif__gifInfo"
            span={24}>
            <span>{I18n.translate('components.flightOptions.searchingFlightsGifInfo')}</span>
          </div>
          <div className="flightSelectionContainerGif flightSelectionContainerGif__info" span={24}>
            <span>{I18n.translate('components.flightOptions.searchingFlightsInfo')}</span>
          </div>
        </div>
      );
  }

  renderFlightSelection() {
    return (
      <div>
        <FlightSelection
          id="flightSelection"
          {...this.props}
          departureFlightsFiltered={this.state.departureFlightsFiltered}
          returnFlightsFiltered={this.state.returnFlightsFiltered}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          startDateChangeCallback={this.handleStartDateChange}
          endDateChangeCallback={this.handleEndDateChange}
          callbackAlterSearch={this.handleAlterSearch}
          callbackSelectFlights={this.props.callbackSelectFlights}
          callbackAlterFlights={this.props.callbackAlterFlights}
          toogleElapsedFlightTime={this.state.toogleElapsedFlightTime}
          toggleDetailsModal={this.state.toggleDetailsModal}
          isGridLoading={this.state.isGridLoading}
          cabinCategory={this.props.filter.cabinCategory}
          ref={e => (this.flightSelection = e)}
          filteredList={this.state.filteredList}
          updateFilters={this.updateFilters}
          originalDepartureFlights={this.state.originalDepartureFlights}
          originalReturnFlights={this.state.originalReturnFlights}
          clearFilters={this.clearFilters}
          updateFilterReturnFlights={this.updateFilterReturnFlights}
          isCallcenterEnabled={this.props.isCallcenterEnabled}
          numPagination={this.state.numPagination}
          callBackShowButtonPaginationReturn={this.setShowButtonPaginationReturn}
        />
        {this.renderButtonLoadingPagination()}
        {this.renderButtonPagination()}
      </div>
    );
  }

  setShowButtonPaginationReturn(value) {
    this.setState({
      showButtonPagination: value
    });
  }

  renderButtonPagination() {
    if (this.state.showButtonPagination)
      return (
        <Button
          id={`btnPagination`}
          bsClass="btnPagination"
          onClick={() => {
            this.setState({ incPagination: this.state.incPagination + 1 }, () => {
              this.firstAvailabilityOrUnavailableFlights(this.state.incPagination);
            });
          }}
          ref={c => {
            this.btnPagination = c;
          }}>
          {I18n.translate('label.seeMoreFlights')}
        </Button>
      );
  }

  render() {
    return (
      <div className="flightSelectionContainer">
        {this.renderFlightSelection()}
        <InfoModal
          id="modalSearchInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalSearchInfo = c;
          }}
        />
        {this.state.alterSearch && (
          <Redirect
            to={{
              pathname: '/',
              state: {
                flightsFilter: this.props.filter
              },
              search: this.props.location.search
            }}
          />
        )}
      </div>
    );
  }
}

FlightSelectionContainer.propTypes = propTypes;
FlightSelectionContainer.defaultProps = defaultProps;

export default FlightSelectionContainer;



// WEBPACK FOOTER //
// ./src/components/flightSelectionContainer/FlightSelectionContainer.jsx